import {
  MicroUnits,
  ProductsEditableColumnConfigItem,
} from "../../../MicroAdjustmentsTable/types";

export const BodyAndLidEmissionFactorsTableMetrics: ProductsEditableColumnConfigItem[] =
  [
    {
      field_key: "body_virgin_ef",
      label: "micro:bodyAndLidEmissionFactorsSection.table.body_virgin_ef",
      defaultUnit: MicroUnits.PERCENTAGE,
    },
    {
      field_key: "body_recycled_ef",
      label: "micro:bodyAndLidEmissionFactorsSection.table.body_recycled_ef",
      defaultUnit: MicroUnits.PERCENTAGE,
    },
    {
      field_key: "lid_virgin_ef",
      label: "micro:bodyAndLidEmissionFactorsSection.table.lid_virgin_ef",
      defaultUnit: MicroUnits.PERCENTAGE,
    },
    {
      field_key: "lid_recycled_ef",
      label: "micro:bodyAndLidEmissionFactorsSection.table.lid_recycled_ef",
      defaultUnit: MicroUnits.PERCENTAGE,
    },
  ];
